module.exports = __webpack_public_path__ + "img/service-nongmaodianshang1.c0ea7aba.svg";